/* ==========================================================================
   RISE RESELLS — theme script (vanilla JS, no dependencies)
   Reads config from <script type="application/json" id="RiseConfig"> in layout/theme.liquid
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  var config = { routes: {}, strings: {}, moneyFormat: '${{amount}}' };
  try {
    var cfgEl = $('#RiseConfig');
    if (cfgEl) config = JSON.parse(cfgEl.textContent);
  } catch (e) { /* keep defaults */ }

  var S = function (key, fallback) { return (config.strings && config.strings[key]) || fallback; };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var animations = doc.body.getAttribute('data-animations') !== 'false' && !reduceMotion;

  /* ---------- Scroll reveal ------------------------------------------------ */
  var revealIO = null;
  function initReveal(scope) {
    var els = $$('.reveal:not([data-rv])', scope);
    if (!els.length) return;
    if (!animations || designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.setAttribute('data-rv', '1'); el.classList.add('is-visible'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealIO.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    }
    els.forEach(function (el) { el.setAttribute('data-rv', '1'); revealIO.observe(el); });
  }

  /* ---------- Header + full-screen mobile menu ----------------------------- */
  var headerCleanup = null;
  function initHeader() {
    if (headerCleanup) { headerCleanup(); headerCleanup = null; }
    var header = $('[data-rise-header]');
    if (!header) return;
    var wrapper = header.closest('.shopify-section');
    if (wrapper) wrapper.classList.add('rise-sticky');

    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var menu = $('[data-mobile-menu]');
    var toggle = $('[data-menu-toggle]', header);
    var closeBtn = menu && $('[data-menu-close]', menu);
    if (!menu || !toggle) { headerCleanup = function () { window.removeEventListener('scroll', onScroll); }; return; }

    function focusables() {
      return $$('a[href], button:not([disabled])', menu).filter(function (el) { return el.offsetParent !== null || el === closeBtn; });
    }
    function open() {
      menu.removeAttribute('inert');
      menu.setAttribute('aria-hidden', 'false');
      menu.classList.add('is-open');
      root.classList.add('menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      setTimeout(function () { var f = focusables(); if (f[0]) f[0].focus(); }, 60);
    }
    function close(returnFocus) {
      menu.classList.remove('is-open');
      root.classList.remove('menu-open');
      menu.setAttribute('aria-hidden', 'true');
      menu.setAttribute('inert', '');
      toggle.setAttribute('aria-expanded', 'false');
      if (returnFocus) toggle.focus();
    }
    var onToggle = function () { open(); };
    var onClose = function () { close(true); };
    var onKey = function (e) {
      if (!menu.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(true); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    var onMenuClick = function (e) {
      var link = e.target.closest('a');
      if (link) close(false);
    };
    var onResize = function () { if (window.innerWidth >= 900) close(false); };

    toggle.addEventListener('click', onToggle);
    if (closeBtn) closeBtn.addEventListener('click', onClose);
    menu.addEventListener('click', onMenuClick);
    doc.addEventListener('keydown', onKey);
    window.addEventListener('resize', onResize);

    headerCleanup = function () {
      window.removeEventListener('scroll', onScroll);
      toggle.removeEventListener('click', onToggle);
      if (closeBtn) closeBtn.removeEventListener('click', onClose);
      menu.removeEventListener('click', onMenuClick);
      doc.removeEventListener('keydown', onKey);
      window.removeEventListener('resize', onResize);
      root.classList.remove('menu-open');
    };
  }

  /* ---------- Sticky "Shop now" bar (homepage) -------------------------------- */
  var ctaObservers = [];
  function initStickyCta() {
    ctaObservers.forEach(function (o) { o.disconnect(); });
    ctaObservers = [];
    var bar = $('[data-sticky-cta]');
    var trigger = $('[data-hero-cta]') || $('[data-rise-hero]');
    if (!bar || !trigger || !('IntersectionObserver' in window)) return;
    var footer = $('[data-rise-footer]');
    var heroGone = false, footerIn = false;
    function update() {
      var show = heroGone && !footerIn;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }
    var heroIO = new IntersectionObserver(function (entries) {
      var e = entries[0];
      // "gone" = the hero button is out of view AND above the viewport (user scrolled past it)
      heroGone = !e.isIntersecting && e.boundingClientRect.top < 0;
      update();
    }, { threshold: 0 });
    heroIO.observe(trigger);
    ctaObservers.push(heroIO);
    if (footer) {
      var footIO = new IntersectionObserver(function (entries) { footerIn = entries[0].isIntersecting; update(); }, { threshold: 0.05 });
      footIO.observe(footer);
      ctaObservers.push(footIO);
    }
  }

  /* ---------- Accordion (FAQ) ----------------------------------------------------- */
  function initAccordions(scope) {
    $$('[data-acc-btn]:not([data-bound])', scope).forEach(function (btn) {
      btn.setAttribute('data-bound', '1');
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-acc-item]');
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Horizontal rails: progress bar -------------------------------------- */
  function initRails(scope) {
    $$('[data-rail]:not([data-bound])', scope).forEach(function (rail) {
      rail.setAttribute('data-bound', '1');
      var bar = rail.parentNode.querySelector('[data-rail-progress] span');
      if (!bar) return;
      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        var ratio = rail.clientWidth / rail.scrollWidth;
        var progress = max > 0 ? rail.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + (progress * (1 - ratio) * 100 / ratio).toFixed(2) + '%) scaleX(' + ratio.toFixed(3) + ')';
      }
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Money formatting ------------------------------------------------------ */
  function formatMoney(cents, format) {
    format = format || config.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    function withDelims(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision; thousands = thousands || ','; decimal = decimal || '.';
      var num = (n / 100).toFixed(precision).split('.');
      return num[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (num[1] ? decimal + num[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (m && m[1]) {
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Toast + cart count ------------------------------------------------------ */
  var toastTimer = null;
  function toast(message, opts) {
    opts = opts || {};
    var el = $('[data-rise-toast]');
    if (!el) return;
    el.classList.toggle('is-error', !!opts.error);
    el.innerHTML = '';
    var span = doc.createElement('span');
    span.textContent = message;
    el.appendChild(span);
    if (opts.link) {
      var a = doc.createElement('a');
      a.href = opts.link;
      a.textContent = opts.linkLabel || S('viewCart', 'View cart');
      el.appendChild(a);
    }
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 500);
    }, opts.error ? 5000 : 3800);
  }

  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !(n > 0);
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
  }
  function refreshCartCount() {
    return fetch(config.routes.cart || '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); return cart; });
  }

  /* ---------- Buttons: loading / added states ------------------------------------------- */
  function setButtonState(btn, state, label) {
    var labelEl = $('.btn__label', btn);
    if (labelEl && !btn.hasAttribute('data-label')) btn.setAttribute('data-label', labelEl.textContent);
    btn.setAttribute('data-state', state);
    if (labelEl) {
      if (state === 'loading') labelEl.textContent = S('adding', 'Adding…');
      else if (state === 'added') labelEl.textContent = S('added', 'Added');
      else labelEl.textContent = label || btn.getAttribute('data-label');
    }
  }

  /* ---------- Add to cart (AJAX) ------------------------------------------------------------ */
  function bindAddToCart(scope) {
    $$('form[data-add-to-cart]:not([data-bound])', scope).forEach(function (form) {
      form.setAttribute('data-bound', '1');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var buttons = $$('[data-atc-btn]', form);
        if (form.id) buttons = buttons.concat($$('[data-atc-btn][form="' + form.id + '"]'));
        var btns = buttons.filter(function (b, i, a) { return a.indexOf(b) === i; });
        var primary = btns[0];
        if (primary && primary.getAttribute('data-state') === 'loading') return;
        btns.forEach(function (b) { setButtonState(b, 'loading'); });
        var fd = new FormData(form);
        fetch(config.routes.cartAdd || '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (out) {
            if (!out.ok || out.data.status) throw new Error(out.data.description || out.data.message || S('error', 'Something went wrong. Please try again.'));
            return refreshCartCount();
          })
          .then(function () {
            btns.forEach(function (b) { setButtonState(b, 'added'); });
            toast(S('addedToast', 'Added to your cart'), { link: config.routes.cartPage || '/cart', linkLabel: S('viewCart', 'View cart') });
            setTimeout(function () { btns.forEach(function (b) { setButtonState(b, 'idle'); }); }, 2200);
          })
          .catch(function (err) {
            btns.forEach(function (b) { setButtonState(b, 'idle'); });
            toast(err.message || S('error', 'Something went wrong. Please try again.'), { error: true });
          });
      });
    });
  }

  /* ---------- Quantity steppers ------------------------------------------------------------------ */
  function bindQty(scope) {
    $$('[data-qty]:not([data-bound])', scope).forEach(function (wrap) {
      wrap.setAttribute('data-bound', '1');
      var input = $('input', wrap);
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-qty-step]');
        if (!btn) return;
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var min = parseInt(input.min || '1', 10);
        var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
        if (input.max) next = Math.min(next, parseInt(input.max, 10));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    $$('form[data-cart-form]:not([data-bound])', scope).forEach(function (form) {
      form.setAttribute('data-bound', '1');
      var t = null;
      form.addEventListener('change', function (e) {
        if (!e.target.matches('[data-cart-qty]')) return;
        clearTimeout(t);
        t = setTimeout(function () {
          var u = doc.createElement('input'); u.type = 'hidden'; u.name = 'update'; u.value = 'Update';
          form.appendChild(u);
          form.submit();
        }, 350);
      });
    });
  }

  /* ---------- Product page: gallery + variants + pinned bar ---------------------------------------- */
  function initProduct(scope) {
    $$('[data-product-root]:not([data-bound])', scope).forEach(function (rootEl) {
      rootEl.setAttribute('data-bound', '1');

      /* gallery */
      var track = $('[data-gallery-track]', rootEl);
      var dots = $$('[data-gallery-dot]', rootEl);
      var slides = track ? $$('.gallery__slide', track) : [];
      function goTo(i) {
        if (!track || !slides[i]) return;
        if (window.innerWidth >= 900) { slides[i].scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      if (track) {
        track.addEventListener('scroll', function () {
          var idx = Math.round(track.scrollLeft / (track.clientWidth || 1));
          var cur = $('[data-gallery-current]', rootEl); if (cur) cur.textContent = idx + 1;
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        }, { passive: true });
        dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
      }

      /* variants */
      var jsonEl = $('[data-product-json]', rootEl);
      var product = null;
      try { product = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (e) { product = null; }
      var form = $('form[data-add-to-cart]', rootEl);
      var idInput = form && $('[data-variant-id]', form);
      var btns = $$('[data-atc-btn]', rootEl);
      var priceEls = $$('[data-price]', rootEl);

      function selectedOptions() {
        return $$('[data-option]', rootEl).map(function (fs) {
          var checked = $('input:checked', fs);
          return checked ? checked.value : null;
        });
      }
      function findVariant(opts) {
        if (!product) return null;
        return product.variants.filter(function (v) {
          return v.options.every(function (o, i) { return opts[i] === o; });
        })[0] || null;
      }
      function renderPrice(v) {
        var html = '';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html = '<span class="price"><s class="price__compare">' + formatMoney(v.compare_at_price) + '</s> <span class="price__now">' + formatMoney(v.price) + '</span></span>';
        } else {
          html = '<span class="price"><span class="price__now">' + formatMoney(v.price) + '</span></span>';
        }
        priceEls.forEach(function (el) { el.innerHTML = html; });
      }
      function renderAvailability(v) {
        btns.forEach(function (b) {
          var label = $('.btn__label', b);
          if (!v) { b.disabled = true; if (label) label.textContent = S('unavailable', 'Unavailable'); return; }
          b.disabled = !v.available;
          b.removeAttribute('data-label');
          if (label) label.textContent = v.available ? (b.getAttribute('data-add-label') || S('add', 'Get vendor')) : S('soldOut', 'Sold out');
          b.setAttribute('data-state', 'idle');
        });
      }
      function markUnavailable() {
        if (!product) return;
        var fieldsets = $$('[data-option]', rootEl);
        var current = selectedOptions();
        fieldsets.forEach(function (fs, pos) {
          $$('input', fs).forEach(function (input) {
            var test = current.slice(); test[pos] = input.value;
            var match = findVariant(test);
            var pill = input.nextElementSibling;
            if (pill) pill.classList.toggle('is-unavailable', !match || !match.available);
          });
        });
      }
      function onVariantChange() {
        var opts = selectedOptions();
        $$('[data-option]', rootEl).forEach(function (fs, i) { var out = $('[data-option-value]', fs); if (out) out.textContent = opts[i]; });
        var v = findVariant(opts);
        if (v && idInput) idInput.value = v.id;
        if (v) {
          renderPrice(v);
          if (history.replaceState) { try { var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url); } catch (e) { /* ignore */ } }
          if (v.featured_media && v.featured_media.id) {
            var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(v.featured_media.id); });
            if (idx > -1) goTo(idx);
          }
        }
        renderAvailability(v);
        markUnavailable();
      }
      $$('[data-option] input', rootEl).forEach(function (i) { i.addEventListener('change', onVariantChange); });
      markUnavailable();

      /* pinned bar: show once the main button leaves the viewport (mobile) */
      var bar = $('[data-atc-bar]', rootEl) || $('[data-atc-bar]');
      var mainBtn = $('[data-main-atc]', rootEl);
      if (bar && mainBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          var show = !e.isIntersecting;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
        }, { threshold: 0 }).observe(mainBtn);
      }
    });
  }

  /* ---------- Related products (fetched section) ------------------------------------------------------ */
  function initRelated(scope) {
    $$('[data-related]:not([data-bound])', scope).forEach(function (el) {
      el.setAttribute('data-bound', '1');
      if (el.querySelector('[data-related-content]')) return; // already rendered
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = doc.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-related]');
        if (fresh && fresh.querySelector('[data-related-content]')) {
          el.innerHTML = fresh.innerHTML;
          initPage(el);
        }
      }).catch(function () { /* related products are optional */ });
    });
  }

  /* ---------- Collection sort ------------------------------------------------------------------------------ */
  function initSort(scope) {
    $$('[data-sort]:not([data-bound])', scope).forEach(function (sel) {
      sel.setAttribute('data-bound', '1');
      sel.addEventListener('change', function () {
        var url = new URL(location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        location.href = url.toString();
      });
    });
  }

  /* ---------- Tabs (home shop section) -------------------------------------------------------- */
  function initTabs(scope) {
    $$('[data-tabs]:not([data-bound])', scope).forEach(function (root) {
      root.setAttribute('data-bound', '1');
      var tabs = $$('[data-tab]', root);
      var panels = $$('.tabs__panel', root);
      function select(i) {
        tabs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); t.tabIndex = n === i ? 0 : -1; });
        panels.forEach(function (p, n) { p.hidden = n !== i; });
        if (panels[i]) { var r = $('[data-rail]', panels[i]); if (r) r.dispatchEvent(new Event('scroll')); }
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var n = (i + d + tabs.length) % tabs.length;
          select(n); tabs[n].focus();
        });
      });
      if (tabs.length) select(0);
    });
  }

  /* ---------- Reviews: form toggle + rail arrows ----------------------------------------------- */
  function initReviews(scope) {
    $$('.rv:not([data-bound]), [data-rv-root]:not([data-bound])', scope).forEach(function (root) {
      root.setAttribute('data-bound', '1');
      var openBtn = $('[data-rv-open]', root);
      var panel = $('[data-rv-panel]', root);
      function toggle(open) {
        if (!panel) return;
        panel.hidden = !open;
        if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var f = $('input, textarea', panel); if (f && window.innerWidth > 900) f.focus(); }
      }
      if (openBtn) openBtn.addEventListener('click', function () { toggle(panel.hidden); });
      if (panel && $('[data-rv-success]', panel)) { toggle(true); panel.scrollIntoView({ block: 'center' }); }
      var rail = $('[data-rail]', root);
      var prev = $('[data-rail-prev]', root), next = $('[data-rail-next]', root);
      function step(d) {
        if (!rail) return;
        var card = rail.firstElementChild;
        var w = card ? card.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: d * w, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }

  /* ---------- Boot ------------------------------------------------------------------------------------------ */
  function initPage(scope) {
    initReveal(scope);
    initAccordions(scope);
    initRails(scope);
    bindAddToCart(scope);
    bindQty(scope);
    initProduct(scope);
    initRelated(scope);
    initSort(scope);
    initTabs(scope);
    initReviews(scope);
  }

  function boot() {
    initHeader();
    initStickyCta();
    initPage(doc);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();

  /* Shopify theme editor: re-init when sections change */
  doc.addEventListener('shopify:section:load', function (e) {
    initHeader();
    initStickyCta();
    initPage(e.target);
  });

  window.RiseTheme = { toast: toast, formatMoney: formatMoney };
})();
